import { Building2Icon, HandshakeIcon, LandmarkIcon, RocketIcon } from 'lucide-react'
import type { Initiative, Pillar, Stat } from '../types/landing'

export const stats: Stat[] = [
  { value: 12, label: 'Años de experiencia y gestión' },
  { value: 3, label: 'Periodos consecutivos', detail: '2014 – 2026' },
]

export const pillars: Pillar[] = [
  {
    number: '01',
    title: 'Finanzas',
    description: 'Aportamos a la estabilidad y fortalecimiento institucional, optimizando el gasto.',
    icon: LandmarkIcon,
    tone: 'navy',
  },
  {
    number: '02',
    title: 'Infraestructura',
    description: 'Participamos en la recuperación del Centro de Eventos Valle del Pacífico.',
    icon: Building2Icon,
    tone: 'gold',
  },
  {
    number: '03',
    title: 'Desarrollo empresarial',
    description: 'Fomentamos iniciativas como ValleImpacta y Fábricas de Productividad.',
    icon: RocketIcon,
    tone: 'maroon',
  },
  {
    number: '04',
    title: 'Articulación regional',
    description: 'Impulsamos clústeres productivos, alianzas y sinergias institucionales para las MiPymes.',
    icon: HandshakeIcon,
    tone: 'gray',
  },
]

export const initiatives: Initiative[] = [
  {
    id: 'centro-eventos',
    name: 'Centro de Eventos Valle del Pacífico',
    description: 'Recuperación de la infraestructura para ferias y eventos de talla internacional.',
    logo: 'https://cdn.magicpatterns.com/uploads/vDoTDDFJJJz51uwAYuyBpz/Centro_de_eventos.webp',
  },
  {
    id: 'valleimpacta',
    name: 'ValleImpacta',
    description: 'Aceleración de empresas con alto potencial de crecimiento en la región.',
    logo: 'https://cdn.magicpatterns.com/uploads/xcAATxJsUzy5trPL8BAdbr/alianza_valleimpacta.webp',
  },
  {
    id: 'fabricas-productividad',
    name: 'Fábricas de Productividad',
    description: 'Asistencia técnica para mejorar la productividad y competitividad de las empresas.',
    logo: 'https://cdn.magicpatterns.com/uploads/jSL3rBWEonEiHYYuDKjVrz/Fabricas.png',
  },
  {
    id: 'reddi',
    name: 'Reddi',
    description: 'Agencia de desarrollo tecnológico que impulsa la innovación empresarial.',
    logo: 'https://cdn.magicpatterns.com/uploads/44JqawoThom3yvBrUEdXjr/reddit.webp',
  },
  {
    id: 'invest-pacific',
    name: 'Invest Pacific',
    description: 'Promoción de inversión nacional y extranjera para Cali y el Valle del Cauca.',
    logo: 'https://cdn.magicpatterns.com/uploads/28NaYMTQNWXaCZgfFNnErG/invest-pacific-324318.jpg',
  },
  {
    id: 'propacifico',
    name: 'ProPacífico',
    description: 'Alianza público-privada por la competitividad del Pacífico colombiano.',
    logo: 'https://cdn.magicpatterns.com/uploads/6FNCMJQTUTUwkB9L2wNAk7/logo-propacifico-color.png',
  },
  {
    id: 'prospera',
    name: 'Prospera Aguablanca',
    description: 'Centro de desarrollo empresarial y empleabilidad en el oriente de Cali.',
    logo: 'https://cdn.magicpatterns.com/uploads/aViJVyFdgRB4fytAQ1sVYD/prospera-logo-2.jpg',
    logoCover: true,
  },
  {
    id: 'nido',
    name: 'Programa Nido',
    description: 'Fortalecimiento de emprendimientos de base tecnológica.',
    logo: 'https://cdn.magicpatterns.com/uploads/aah1a6JXqiE8dJ38cBhopV/programa_nido.png',
    logoCover: true,
  },
  {
    id: 'exponegocios',
    name: 'Exponegocios 2026',
    description: 'Feria que conecta a las empresas de la región con nuevos mercados.',
    logo: 'https://cdn.magicpatterns.com/uploads/bYra9PhvTHrupzfNYvkGZm/EXPONEGOCIOS.jpg',
    logoCover: true,
  },
  {
    id: 'fintech-forum',
    name: 'Cali Valle del Cauca Fintech Forum',
    description: 'Encuentro que impulsa la innovación financiera y tecnológica regional.',
    logo: 'https://cdn.magicpatterns.com/uploads/bjhfJQQJUrxhMUVnbjQ1VR/CALI_FINTECH.png',
    logoCover: true,
  },
]
